import {
  PerformanceTimeSeriesRequestContract,
  PerformanceTimeSeriesResponseContract,
} from './contract';

export const fetchRequestContract = new PerformanceTimeSeriesRequestContract();

export const fetchResponseContract = new PerformanceTimeSeriesResponseContract({
  requestContract: fetchRequestContract,
});
